import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router'
import Day from './day'
import Week from './week'

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/calendar/day/:date"
          element={<Day />}
        />
        <Route
          path="/calendar/week/:date"
          element={<Week />}
        />
      </Routes>
    </BrowserRouter>
  )
}
